import React, { memo, useState } from 'react';
import styles from './styles.module.scss';
import { IEmailTemplate } from './useSendOffer';
import { LanguageSelect, SunTextEditor } from 'components';
import { Row, Col, Form, Input, Select, Typography } from 'components';
import { PERMISSIONS } from '../../../../constants/permissions';
import { useAccessControl } from '../../../../components/common/accessControl/useAccessControl';
import { ContactPersonAddEdit } from '../../../../components/common/contactPerson/addEdit';

const { Title } = Typography;

interface EmailFormProps {
  form: any;
  contactPersons: any[];
  currentUser: any;
  clientId: string;
  emailTemplate: IEmailTemplate;
  handleContactPersonChange: (value: string) => void;
  onLanguageChange: (value: string) => void;
  handleEmailTemplateChange: (value: string, key: 'subject' | 'content') => void;
}

export const EmailForm: React.FC<EmailFormProps> = memo(
  ({
    form,
    clientId,
    contactPersons,
    currentUser,
    emailTemplate,
    handleContactPersonChange,
    onLanguageChange,
    handleEmailTemplateChange,
  }) => {
    const { hasAccess } = useAccessControl();
    const [openContactPersonModal, setOpenContactPersonModal] = useState(false);

    return (
      <>
        <Form style={{ marginTop: 20 }} form={form} layout="vertical">
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item label="Contact Person" name="contactPersonId">
                <Select
                  size="large"
                  placeholder="Select contact person"
                  onChange={handleContactPersonChange}
                  onAdd={() => setOpenContactPersonModal(true)}
                  showAdd={hasAccess(PERMISSIONS.clients.contact_person.write)}
                  options={contactPersons}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Language" name="languageId">
                <LanguageSelect size="large" onChange={onLanguageChange} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Title level={5} className={styles.sectionTitle}>
                Email
              </Title>
            </Col>
            <Col span={12}>
              <Form.Item label="From" name="from" initialValue={currentUser?.email}>
                <Input disabled size="large" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Subject" name="subject" initialValue={emailTemplate.subject}>
                <Input
                  size="large"
                  placeholder="Enter email subject"
                  value={emailTemplate.subject}
                  onChange={(e) => handleEmailTemplateChange(e.target.value, 'subject')}
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <div className={styles.emailLabel}>Email Body</div>
              <SunTextEditor
                value={emailTemplate.content}
                onChange={(value: string) => handleEmailTemplateChange(value, 'content')}
              />
            </Col>
          </Row>
        </Form>
        <ContactPersonAddEdit
          entityName={'CLIENT'}
          modalState={openContactPersonModal}
          clientId={clientId}
          onModalStateChange={() => setOpenContactPersonModal(false)}
        />
      </>
    );
  }
);
